'use client';

import { TaxBadge } from '@/components/ui/Tax';
import { getCountryCodeFromChannel } from '@/lib/const';
import { formatPrice } from '@/lib/utils/formatPrice';
import { useLocale, useTranslations } from 'next-intl';
import type { FC } from 'react';
import styles from './LinePrice.module.scss';

export interface LinePriceProps {
  price: number;
  currency: string;
  quantity?: number;
  originalPrice?: number;
  channelSlug?: string;
  countryCode?: string;
  isGift?: boolean;
  className?: string;
  'data-testid'?: string;
}

export const LinePrice: FC<LinePriceProps> = ({
  price,
  currency,
  quantity = 1,
  originalPrice,
  channelSlug,
  countryCode: countryCodeProp,
  isGift = false,
  className,
  'data-testid': testId,
}) => {
  const t = useTranslations('checkout');
  const locale = useLocale();
  const countryCode = countryCodeProp || getCountryCodeFromChannel(channelSlug);
  const isDiscounted = originalPrice && originalPrice > price;

  const formatAmount = (amount: number) => {
    return formatPrice(amount, currency, locale);
  };

  if (isGift) {
    return (
      <div className={className ?? styles.container}>
        <span className={styles.complimentary}>{t('cart.complimentary')}</span>
      </div>
    );
  }

  return (
    <div className={className ?? styles.container} data-testid={testId}>
      <span className={styles.price}>{formatAmount(price * quantity)}</span>
      {isDiscounted && (
        <span className={styles.originalPrice}>{formatAmount(originalPrice * quantity)}</span>
      )}
      <TaxBadge countryCode={countryCode} />
    </div>
  );
};
